import { GetterTree, ActionTree, MutationTree } from 'vuex';

export enum ReadyType {
	JW_ID = 'jwId',
	USER_SETTINGS_LOADED = 'userSettingsLoaded',
	WEBLOCALE_SET = 'webLocaleSet', // either setting from persisted store value or detect by geo ip
	LOGIN_FINISHED = 'loginFinished',
	EXPERIMENTS_LOADED = 'experimentsLoaded',
	EXPERIMENTS_INIT = 'experimentInit',
	SNOWPLOW_INIT = 'snowplowInit',
	PRO_MODAL_ACTIVATED = 'proModalActivated',
	CONSENT_PARTNERS_ANSWERED = 'consentPartnersAnswered', // either `true` or `false`, but not `null`—we expect this to only happen once per user session, for simplicity's sake
}

// STATE
const state = () => {
	return [
		ReadyType.JW_ID,
		ReadyType.USER_SETTINGS_LOADED,
		ReadyType.WEBLOCALE_SET,
		ReadyType.LOGIN_FINISHED,
		ReadyType.EXPERIMENTS_LOADED,
		ReadyType.EXPERIMENTS_INIT,
		ReadyType.SNOWPLOW_INIT,
		ReadyType.PRO_MODAL_ACTIVATED,
		ReadyType.CONSENT_PARTNERS_ANSWERED,
	].reduce((root, key) => {
		root[key] = false;
		return root;
	}, {} as Record<ReadyType, boolean>);
};

export type ReadyState = ReturnType<typeof state>;

// GETTERS
const getters: GetterTree<ReadyState, any> = {};

// ACTIONS
const actions: ActionTree<ReadyState, any> = {};

// MUTATIONS
const mutations: MutationTree<ReadyState> = {
	SET_READY(state, readyType: ReadyType) {
		state[readyType] = true;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
